import React, { useState } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import Input from '../input';
import Tooltip from '../tooltip';
import { TooltipContext } from '../tooltip/tooltip-context';
import { Menu, MenuItem } from '../menu/menu';
import { SelectContext, defaultConfig, useSelect } from './select-context';
const Option = styled(MenuItem) `
  min-width: 100px;
`;
export const SelectOption = (props) => {
    const { handleSelected, handleTooltipVisible } = useSelect();
    const handleClick = (value) => {
        handleSelected === null || handleSelected === void 0 ? void 0 : handleSelected(value);
        handleTooltipVisible === null || handleTooltipVisible === void 0 ? void 0 : handleTooltipVisible(false);
    };
    return (React.createElement(Option, { itemKey: props.value, onClick: () => handleClick(props.value) }, props.children));
};
export const Select = (props) => {
    const [selected, setSelected] = useState();
    const [visible, setVisible] = useState(false);
    const handleSelected = (value) => {
        var _a;
        (_a = props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, value);
        setSelected(value);
    };
    const controlledValue = props.value || selected;
    return (React.createElement(SelectContext.Provider, { value: Object.assign(Object.assign({}, defaultConfig), { selected: controlledValue, handleSelected, handleTooltipVisible: setVisible }) },
        React.createElement(TooltipContext.Provider, { value: {
                animation: 'opacity',
                showArrow: false,
                outsideCloseable: true,
            } },
            React.createElement(Tooltip, { className: cx('select', props.className), style: props.style, onClickOutside: () => setVisible(false), visible: visible, placement: "bottomStart", trigger: "click", content: React.createElement(Menu, { selectedKeys: [controlledValue] }, props.children) },
                React.createElement(Input, { onChange: (e) => { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e.target.value); }, onClick: () => setVisible(true), style: { width: '100px' }, value: controlledValue === null || controlledValue === void 0 ? void 0 : controlledValue.toString() })))));
};
